import { type IEventHandler, type IEventEmitter, type IApiManager } from '@source-digital/sd-app-core'
import { type RootMessenger } from './root'

export class LocalEventEmitter implements IEventEmitter {
  constructor (
    public readonly id: string,
    private readonly rootMessenger: RootMessenger
  ) {}

  emit (eventName: string, data: any, option?: { to?: string }): void {
    this.rootMessenger.emit(eventName, data, this.id, option?.to)
  }

  on<T = any> (eventName: string, handler: IEventHandler<T>): void {
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    this.rootMessenger.on(eventName, handler, this.id)
  }

  off<T = any> (eventName: string, handler: IEventHandler<T>): void {
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    this.rootMessenger.off(eventName, handler, this.id)
  }

  once<T = any> (eventName: string, handler: IEventHandler<T>): void {
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    this.rootMessenger.once(eventName, handler, this.id)
  }
}

export class LocalClientApiManager implements IApiManager {
  constructor (
    public readonly id: string,
    private readonly rootMessenger: RootMessenger
  ) {}

  register (name: string, apiDefinition: unknown): void {
    this.rootMessenger.registerClientApi(this.id, name, apiDefinition)
  }

  unregister (name: string): void {
    this.rootMessenger.unregisterClientApi(this.id, name)
  }

  /**
   * @param name
   * @returns API provided by broker plugin
   */
  async get<API> (name: string): Promise<API> {
    return await Promise.resolve(this.rootMessenger.getApi<API>(name))
  }
}
